/**
 * Convert a local Date to a UTC date set to midnight, preserving the local calendar date.
 *
 * This is the reverse of utcToLocal. It uses local accessors (getFullYear,
 * getMonth, getDate) so that the local calendar date is preserved in the resulting UTC midnight
 * regardless of the original local time of day.
 *
 * In UTC+ timezones, a local calendar date's midnight has a UTC representation on the previous
 * calendar day (e.g. 2025-07-10 00:00 local in UTC+5 = 2025-07-09 19:00 UTC). Using UTC
 * accessors here would extract July 9 instead of July 10. Local accessors correctly extract
 * July 10.
 */
export const toUTCDateMidnight = (date: Date): Date => {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
}
